import React from 'react';
import { Card, Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

const { Text } = Typography;

const StateWarning = ({ message }) => {
    {/*const handleBackClick = () => {
        window.history.back();
    };*/}

    return (
        <div className="page-container">
            <div className="empty-state-wrapper">
                <Card className="empty-state-card">
                    <WarningOutlined style={{fontSize: '48px', color: '#faad14'}}/>
                    <Text className="empty-state-text">{message}</Text>
                    {/*<span
                    className="empty-state-back-link"
                    onClick={handleBackClick}
                >
                    Назад
                </span>*/}
                </Card>
            </div>
        </div>
    );
};

export default StateWarning;